import React from "react";
import { useIntl } from "react-intl";
import { Modal, ModalFooter, Button } from "@folio/stripes/components";
import { formatIsbn } from "../../utils/isbn";
import styles from "./PendingVerificationDialog.module.css";
export var PendingVerificationDialog = function (_a) {
    var open = _a.open, isbn = _a.isbn, pendingTitle = _a.pendingTitle, onOpenVerification = _a.onOpenVerification, onClose = _a.onClose;
    var formatMessage = useIntl().formatMessage;
    var fieldLabel = function (id) {
        return formatMessage({
            id: "ui-br-legaldeposits.enforcement.pendingVerification.field.".concat(id),
        });
    };
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.enforcement.pendingVerification.title",
        }), onClose: onClose, size: "small", footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: onOpenVerification, id: "pending-verification-open" }, formatMessage({
                id: "ui-br-legaldeposits.enforcement.pendingVerification.open",
            })),
            React.createElement(Button, { onClick: onClose, id: "pending-verification-close" }, formatMessage({
                id: "ui-br-legaldeposits.enforcement.pendingVerification.close",
            }))) },
        React.createElement("p", null, formatMessage({
            id: "ui-br-legaldeposits.enforcement.pendingVerification.intro",
        })),
        pendingTitle && (React.createElement("dl", { className: styles.definitionList },
            pendingTitle.name && (React.createElement(React.Fragment, null,
                React.createElement("dt", null, fieldLabel("name")),
                React.createElement("dd", null, pendingTitle.name))),
            pendingTitle.author && (React.createElement(React.Fragment, null,
                React.createElement("dt", null, fieldLabel("author")),
                React.createElement("dd", null, pendingTitle.author))),
            pendingTitle.year != null && (React.createElement(React.Fragment, null,
                React.createElement("dt", null, fieldLabel("year")),
                React.createElement("dd", null, pendingTitle.year))),
            pendingTitle.publisherNameToCheck && (React.createElement(React.Fragment, null,
                React.createElement("dt", null, fieldLabel("publisher")),
                React.createElement("dd", null, pendingTitle.publisherNameToCheck))),
            isbn && (React.createElement(React.Fragment, null,
                React.createElement("dt", null, fieldLabel("isbn")),
                React.createElement("dd", null, formatIsbn(isbn))))))));
};
